module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-panel weui-panel_access"
  }, [_c('div', {
    staticClass: "weui-panel__hd"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__bd"
  }, [_vm._l((_vm.linkObj), function(item) {
    return (!_vm.titleOnly) ? [_c('a', {
      staticClass: "weui-media-box weui-media-box_appmsg",
      attrs: {
        "href": item.link
      },
      on: {
        "click": function($event) {
          _vm.callbackFun(item.fun)
        }
      }
    }, [(item.img) ? _c('div', {
      staticClass: "weui-media-box__hd"
    }, [_c('img', {
      staticClass: "weui-media-box__thumb",
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "weui-media-box__bd"
    }, [_c('h4', {
      staticClass: "weui-media-box__title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "weui-media-box__desc"
    }, [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (item.info) ? _c('ul', {
      staticClass: "weui-media-box__info"
    }, [_c('li', {
      staticClass: "weui-media-box__info__meta"
    }, [_vm._v(_vm._s(item.info.source))]), _vm._v(" "), _c('li', {
      staticClass: "weui-media-box__info__meta"
    }, [_vm._v(_vm._s(item.info.time))]), _vm._v(" "), _c('li', {
      staticClass: "weui-media-box__info__meta weui-media-box__info__meta_extra"
    }, [_vm._v(_vm._s(item.info.extra))])]) : _vm._e()])])] : _vm._e()
  }), _vm._v(" "), (_vm.titleOnly) ? _c('vw-cells', [_vm._l((_vm.linkObj), function(item) {
    return [_c('vw-list-item', {
      attrs: {
        "title": item.title,
        "src": item.img,
        "href": item.link
      }
    })]
  })], true) : _vm._e()], true), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__ft"
  }, [_c('a', {
    staticClass: "weui-cell weui-cell_access weui-cell_link",
    attrs: {
      "href": _vm.moreLink
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v(_vm._s(_vm.moreInfo))]), _vm._v(" "), _c('span', {
    staticClass: "weui-cell__ft"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6aac02d8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/panel.vue
// module id = 259
// module chunks = 0